export default function numberFormat(value: number, notCurrency: boolean) {
  if (notCurrency) {
    return new Intl.NumberFormat('es-AR').format(value);
  }
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'USD' }).format(value);
}
